module.exports = __webpack_public_path__ + "img/logo-b.c61af7fd.svg";